import { render, staticRenderFns } from "./CommodityAdd.vue?vue&type=template&id=a4721a42&scoped=true"
import script from "./CommodityAdd.vue?vue&type=script&lang=js"
export * from "./CommodityAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4721a42",
  null
  
)

export default component.exports